import { BodyText as StyledBodyText } from './BodyText.styles';
import * as React from 'react';

export interface BodyTextProps {
  /**
   * Body text contents.
   */
  label?: string;
  /**
   * How heavy is the body text's weight?
   */
  weight: 'regular' | 'light' | 'bold';
  /**
   * Corresponds to font size, default is small.
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * If true, text is grey.
   */
  grey?: boolean;
  /**
   * If true, text is primary color.
   */
  primary?: boolean;
  /**
   * If true text will be white.
   */
  white?: boolean;
  /**
   * If true, text will be italicized.
   */
  italics?: boolean;
  /**
   * If true, text direction is displayed as left to right.
   */
  ltrDirection?: boolean;
  /**
   * If true, the text will not wrap.
   */
  nowrap?: boolean;
  /**
   * Optional children React Components.
   */
  children?: React.ReactNode;
  /**
   * Optional margin
   */
  margin?: string;

  'data-testid'?: string;

  overflowWrapBreak?: boolean;
}

/**
 * The main text contents of the page.
 */
export const BodyText: React.FC<BodyTextProps> = ({
  weight = 'regular',
  size = 'small',
  label,
  grey = false,
  italics = false,
  primary = false,
  ltrDirection = false,
  children,
  nowrap = false,
  overflowWrapBreak = false,
  ...props
}: BodyTextProps) => {
  return (
    <StyledBodyText
      weight={weight}
      size={size}
      grey={grey}
      primary={primary}
      italics={italics}
      ltrDirection={ltrDirection}
      nowrap={nowrap}
      overflowWrapBreak={overflowWrapBreak}
      {...props}
    >
      {label}
      {children}
    </StyledBodyText>
  );
};

export default BodyText;
